import api from 'helpers/api';

export function fetchCustomer(customerId) {
  return api.backend
    .get(`customers/${customerId}`)
    .then(response => response.data.customer);
}

export function fetchCustomerCredit(customerId) {
  return api.backend
    .get('customer_credit', { params: { customer_id: customerId } })
    .then(response => response.data.customerCredit);
}



// WEBPACK FOOTER //
// ./src/api/customers.js